var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogWrapper',{staticClass:"confirm-delete-dialog",attrs:{"close-on-cancel":"","titleI18nKey":`${_vm.i18nPrefix}.title.tip`,"show":_vm.show},on:{"update:show":function($event){_vm.show=$event},"save":_vm.handleSave}},[_c('div',[_vm._v(_vm._s(_vm.$t(`${_vm.i18nPrefix}.message.deleteSearchTemplate`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }